import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vueI18n from '@/plugins/vue-i18n'

Vue.use(VueI18n)

export default ({ app, store, $storage }, inject) => {
  // Set i18n instance on app
  // This way we can use it in middleware and pages asyncData/fetch

  // get the last known locale or fallback to en
  const locale = $storage.getUniversal('i18n') || 'en'
  const fallbackLocale = store.state.fallbackLocale || 'en'
  store.commit('setFallbackLocale', fallbackLocale)
  store.commit('setLocale', locale)

  // create a localization instance
  const _vueI18n = new VueI18n(vueI18n(locale, fallbackLocale))
  app.i18n = _vueI18n
  inject('i18n', _vueI18n)

  // We decorate translation-retrieving functions so that empty strings
  // (effectively untranslated strings) are replaced with translations from the fallback locale
  Vue.prototype.$t = function(...args) {
    const result = this.$i18n.t.apply(this.$i18n, args)
    const resultFallbackLocale = this.$i18n.t(args[0], fallbackLocale)
    if (result === '' && resultFallbackLocale && resultFallbackLocale !== '') {
      return resultFallbackLocale
    }
    return result
  }

  Vue.prototype.$tc = function(...args) {
    const result = this.$i18n.tc.apply(this.$i18n, args)
    const resultFallbackLocale = this.$i18n.t(args[0], fallbackLocale)
    if (result === '' && resultFallbackLocale && resultFallbackLocale !== '') {
      return resultFallbackLocale
    }
    return result
  }
}
